module.exports = __webpack_public_path__ + "img/jmof.4227ae64.png";